import { useContext } from 'react'
import { TelemetryDataContext } from '../context/TelemetryDataContext'

export default function ClassProgress() {
  const { stats } = useContext(TelemetryDataContext)
  const passRate = stats?.passRate ?? 0
  const aiUsage = stats?.aiUsagePercent ?? 0

  return (
    <div className="class-progress" style={{ padding: '24px' }}>
      <h2>Class Progress</h2>
      <div className="ai-usage-section" style={{ marginTop: '34px', marginBottom: '30px' }}>
        <div className="ai-usage-label" style={{ fontSize: '16px', marginBottom: '10px' }}>AI Usage</div>
        <div className="ai-usage-stats">
          <div className="ai-stat" style={{ fontSize: '14px' }}>
            <div className="ai-indicator productive"></div>
            <span className="ai-label">Using AI</span>
            <span className="ai-value">{aiUsage}%</span>
          </div>
          <div className="ai-stat" style={{ fontSize: '14px' }}>
            <div className="ai-indicator unproductive"></div>
            <span className="ai-label">Not using AI</span>
            <span className="ai-value">{100 - aiUsage}%</span>
          </div>
        </div>
      </div>
      <div className="passrate-section" style={{ marginBottom: '8px' }}>
        <div className="passrate-label">Passrate</div>
        <div className="passrate-bar" style={{ height: '32px' }}>
          <div className="passrate-fill" style={{ width: `${passRate}%` }}>
            <span>{passRate}%</span>
          </div>
        </div>
      </div>
    </div>
  )
}